module.exports = __webpack_public_path__ + "un-environment.d0ccb613767a906c8ecf78bf6c68f852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/un-environment.png
// module id = 468
// module chunks = 0